import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: replace with your real Firebase config
const firebaseConfig = {
  // apiKey: 'YOUR_API_KEY',
  // authDomain: 'YOUR_AUTH_DOMAIN',
  // projectId: 'YOUR_PROJECT_ID',
  // storageBucket: 'YOUR_STORAGE_BUCKET',
  // messagingSenderId: 'YOUR_MESSAGING_SENDER_ID',
  // appId: 'YOUR_APP_ID',
    apiKey: "AIzaSyBrV-BJFP5oXbJ-nJ7gq7_sGnnzobNcd1w",
  authDomain: "hyperhex-invoicely.firebaseapp.com",
  projectId: "hyperhex-invoicely",
  storageBucket: "hyperhex-invoicely.firebasestorage.app",
  messagingSenderId: "614047968140",
  appId: "1:614047968140:web:6d309464efcff7c71b04a9",
  measurementId: "G-F6CRZ449R7"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
